export const REVIEW_STATUS = {
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  UNDER_REVIEW: 'UNDER_REVIEW',
  SUBMITTED: 'SUBMITTED',
};
